var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_user-agent.js
// module id = 168
// module chunks = 0